import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { urlParamKeys } from '@ctct/infrastructure-layer';

export const useIsSmsBundle = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search).get(urlParamKeys.affSmsBundle) === 'true', [search]);
};
